"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginFieldWrapper = exports.LoginHeading = exports.LoginInnerPanel = exports.LoginOuterPanel = void 0;
/*
 * © 2023 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = __importDefault(require("styled-components"));
const Text_1 = require("../Text");
const Formik_1 = require("../Formik");
const Layout_1 = require("../Layout");
exports.LoginOuterPanel = (0, styled_components_1.default)(Layout_1.OuterPanel) `
  margin: 0px;
  padding: 0px;
  width: 420px;
`;
exports.LoginInnerPanel = (0, styled_components_1.default)(Layout_1.InnerPanel) `
  margin-left: 10px;
  margin-right: 10px;
  padding: 20px;
`;
exports.LoginHeading = (0, styled_components_1.default)(Text_1.Heading) `
  margin: 0;
`;
exports.LoginFieldWrapper = (0, styled_components_1.default)(Formik_1.FieldWrapper) `
  grid-template-columns: fit-content(200px) auto;
  grid-column-gap: 10px;
`;
//# sourceMappingURL=components.js.map